import React from 'react';
import { Helmet } from 'react-helmet';

type AdobeAnalyticsProps = {
  scriptSrc: string;
};

export const AdobeAnalytics = ({ scriptSrc }: AdobeAnalyticsProps): JSX.Element => (
  <Helmet>
    <script type="text/plain" className="optanon-category-C0004">{`
            var scriptTag = document.createElement('script');
            scriptTag.async = true;
            scriptTag.src = '//assets.adobedtm.com/9215900255c9/17f1b4dd3439/${scriptSrc}.js';
            document.body.appendChild(scriptTag);
        `}</script>
  </Helmet>
);
